import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Angel Pacheco

 Description: Alternative combined parser to address changes in navigation data contract
*/
import Immutable from 'immutable';
import { NAVIGATION_MENU_ID_MORE, NAVIGATION_MENU_ID_PROFILE } from '../../../id';
import getClassicLink from './get-classic-link';
import getClassicParentLink from './get-classic-parent-link';
import getContainerIds from '../get-container-ids';
var CONTAINER_NAMES = {
  HAMBURGER: 'HAMBURGER',
  PROFILEHEADER: 'PROFILEHEADER',
  FOOTER: 'FOOTER'
}; // map properties from new link contract to old

var getValidLinks = function getValidLinks(rawLinks) {
  return rawLinks.map(function (link) {
    return getClassicLink(link);
  });
};

var _parseMobileNavigationConfig = function _parseMobileNavigationConfig(_ref) {
  var _ref$containers = _ref.containers,
      containers = _ref$containers === void 0 ? [] : _ref$containers,
      menuType = _ref.menuType;
  // get links from payload, according to expected structure
  var links = containers.reduce(function (topLinks, container) {
    // We only parse the requested menuType
    if (container.name === menuType) {
      return container.sections.reduce(function (allLinks, section) {
        var hasSectionLinks = Array.isArray(section.links);

        if (section.type === 'PARENT' && hasSectionLinks) {
          // deal with named sections with sub-links
          var subLinks = getValidLinks(section.links);
          allLinks.push(getClassicParentLink(section, subLinks));
        } else if (section.type === 'LINKS' && hasSectionLinks) {
          // deal with top-level links
          return allLinks.concat(getValidLinks(section.links));
        }

        return topLinks.concat(allLinks);
      }, []);
    } else {
      return topLinks;
    }
  }, []);
  return Immutable.OrderedMap(links);
};

export default (function (containers) {
  if (!containers || !containers.length) {
    return {};
  }

  var containerIds = getContainerIds(containers);
  var menus = containerIds[CONTAINER_NAMES.HAMBURGER] ? [[NAVIGATION_MENU_ID_MORE, _parseMobileNavigationConfig({
    containers: containers,
    menuType: CONTAINER_NAMES.HAMBURGER
  })]] : [];

  if (containerIds[CONTAINER_NAMES.PROFILEHEADER]) {
    menus.push([NAVIGATION_MENU_ID_PROFILE, _parseMobileNavigationConfig({
      containers: containers,
      menuType: CONTAINER_NAMES.PROFILEHEADER
    })]);
  }

  return {
    mastheadNavigationConfig: Immutable.OrderedMap(menus),
    footerNavigationConfig: _parseMobileNavigationConfig({
      containers: containers,
      menuType: CONTAINER_NAMES.FOOTER
    })
  };
});